module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f63b.d4d91a5f.svg";